{
  "selectHowUsersNotifiedWhen": "Select how users will be notified when an incident moves from Alert to Lockdown phase.",
  "sendsAutomatedVoiceCallAll": "Sends an automated voice call to all campus users",
  "sendsPushNotificationAllCampus": "Sends a push notification to all campus users",
  "lockdownAlertMethodUpdatedSuccessfully": "Lockdown Alert Method updated successfully"
}
